import { createFileRoute } from '@tanstack/react-router';

import { WalletPage } from './WalletPage';

export const Route = createFileRoute('/_protected/_consumer/wallet/')({
  component: WalletPage,
});
